/*
 * @Author: zhechuan.Wang
 * @Date: 2023-12-07 14:43:32
 * @LastEditors: zhechuan.Wang
 * @LastEditTime: 2024-01-05 16:52:00
 * @Description: 树接口
 * @FilePath: \gfmis-card-ppt\src\api\cardTree.js
 */
import axiosApi from './AxiosApi.js';
const baseUrl = '/anno/CardTree';

const [methodGet, methodPost, methodPut, methodDelete] = ['GET', 'POST', 'PUT', 'DELETE'];

export default {

  // divTree(data) {
  //   return axiosApi({
  //     method: methodPost,
  //     url: `${baseUrl}/divTree`,
  //     data,
  //   });
  // },
  divTree(data) {
    let url = `${baseUrl}/divTree`
    if (data?.mofDivCode) {
      url = `${baseUrl}/divTree?mofDivCode=${data.mofDivCode}`
    }
    return axiosApi({
      method: methodGet,
      url
    });
  },
};
